/**
 * stores/ui.ts
 *
 * UI state management store
 */

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUIStore = defineStore('ui', () => {
    // Error dialog state
    const errorDialogOpen = ref(false)
    const currentError = ref<unknown>(null)

    // set when a GPerson is augmented from comment author info, so kept-alive pages can
    // refresh their avatars next time they're reactivated, even if their route params didn't change
    const profilesUpdated = ref(false)

    // Actions
    function showError (error: unknown) {
        currentError.value = error
        errorDialogOpen.value = true
    }

    function closeErrorDialog () {
        errorDialogOpen.value = false
    }

    function markProfilesUpdated () {
        profilesUpdated.value = true
    }

    // reads and resets the flag in one step, so callers only react to it once
    function consumeProfilesUpdated (): boolean {
        const updated = profilesUpdated.value
        profilesUpdated.value = false
        return updated
    }

    function resetState () {
        errorDialogOpen.value = false
        currentError.value = null
        profilesUpdated.value = false
    }

    return {
        errorDialogOpen,
        currentError,
        resetState,
        showError,
        closeErrorDialog,

        markProfilesUpdated,
        consumeProfilesUpdated,
    }
})
